export default __webpack_public_path__ + "static/media/Flower-Cake.fa7451ba.jpg";